export const LOGIN_ERRORS = {
  ACCOUNT_DOES_NOT_EXIST: "ACCOUNT_DOES_NOT_EXIST",
  INCORRECT_PASSWORD: "INCORRECT_PASSWORD",
  CANNOT_LOGIN_PASSWORD: "CANNOT_LOGIN_PASSWORD",
}
